import { useMutation } from '@tanstack/react-query'

import { acceptOffer } from 'src/services/subscriptionApi'

export const useAcceptOfferMutation = () => {
  return useMutation({
    mutationFn: acceptOffer,
  })
}
